import React, { useEffect, useMemo, useState } from "react";
import CountUp from "react-countup";
import { Card, CardBody } from "reactstrap";
import FeatherIcon from "feather-icons-react";
import CardWidgetSkeleton from "Components/Common/CardWidgetSkeleton";
import { useParams } from "react-router-dom";
import { getTotalPaymentsCount } from "common/services/payments.service";
import { Link } from "react-router-dom";
import PaymentsModal from "pages/Payments/PaymentsModal";

const TotalActiveContracts = () => {
  const { id: mdaId } = useParams();
  const [loading, setLoading] = useState(false);
  const [totalActiveContracts, setTotalActiveContracts] = useState(0);
  const [totalContracts, setTotalContracts] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        const response: any = await getTotalPaymentsCount({
          mdaId,
        });
        setTotalContracts(response?.totalCount);
      } catch (error) {
        console.warn("Error fetching total active contracts", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [mdaId]);

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        const response: any = await getTotalPaymentsCount({
          mdaId,
          active: true,
        });
        setTotalActiveContracts(response?.totalCount);
      } catch (error) {
        console.warn("Error fetching total active contract", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [mdaId]);

  const percentageValue = useMemo(() => {
    if (totalContracts === 0) return 0;
    return (totalActiveContracts / totalContracts) * 100;
  }, [totalActiveContracts, totalContracts]);

  const toggleModal = (e?: React.MouseEvent) => {
    if (e) {
      e.preventDefault();
    }
    setIsModalOpen(!isModalOpen);
  };

  if (loading) {
    return <CardWidgetSkeleton />;
  }

  const filter = {
    mda: {
      value: mdaId,
      label: "",
    },
    status: "active",
  };

  return (
    <Link to={`#`} onClick={toggleModal}>
      <Card className="card-animate">
        <CardBody>
          <div className="d-flex justify-content-between">
            <div>
              <p className="fw-medium text-muted mb-0">
                Total Active Contracts
              </p>
              <h2 className="mt-4 ff-secondary cfs-22 fw-semibold">
                <span className="counter-value" data-target="3">
                  <CountUp start={0} end={totalActiveContracts} duration={2} />
                </span>
                {/* m{" "} */}
              </h2>
              <p className="mb-0 text-muted text-truncate">
                <span className="badge bg-light text-warning mb-0 me-1">
                  {/* <i className="ri-arrow-down-line align-middle"></i>  */}
                  {percentageValue.toFixed(2)}%
                </span>
                total contracts
              </p>
            </div>
            <div>
              <div className="avatar-sm flex-shrink-0">
                <span className="avatar-title bg-info-subtle rounded-circle fs-2">
                  <FeatherIcon icon="file-text" className="text-success" />
                </span>
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
      <PaymentsModal
        isOpen={isModalOpen}
        toggle={toggleModal}
        title="Number of Contracts"
        filter={filter}
      />
    </Link>
  );
};

export default TotalActiveContracts;
